import { render, staticRenderFns } from "./UploadFileWidget.vue?vue&type=template&id=c5a178ae&scoped=true&"
import script from "./UploadFileWidget.vue?vue&type=script&lang=js&"
export * from "./UploadFileWidget.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileWidget.vue?vue&type=style&index=0&id=c5a178ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a178ae",
  null
  
)

export default component.exports